exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.v-icon .mdi .mdi-eye .theme--light {\n  color: green;\n}\n.flex.sort_number {\n  max-width: 11rem;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n  margin-right: 1rem;\n  margin-left: auto;\n}\n", ""]);

